module.exports = __webpack_public_path__ + "img/b-2.1646ba9.png";